<!-- Sección Superior: Avatar + Datos -->
<div class="row align-items-start">
    <!-- Avatar -->
    <div class="col-lg-3 col-md-4 order-first">
        <div class="img-user">
            <ng-container *ngIf="usuario.avatar === 'av-1.png'; else elseTemplate">
                <img [src]="imageUrl" class="img-fluid rounded-circle user-avatar">
            </ng-container>
            <ng-template #elseTemplate>
                <img [src]="usuario._id | mediaUsuariosPipe: usuario.avatar | safe" 
                     [alt]="usuario.avatar" 
                     class="img-fluid rounded-circle user-avatar">
            </ng-template>
        </div>
    </div>

    <!-- Datos Principales -->
    <div class="col-lg-9 col-md-8">
        <div class="row">
            <div class="col-md-6 data-column">
                <div class="data-group">
                    <span class="data-label">Trámite:</span>
                    <span class="data-value highlight">{{ solicitud.actividad.nombre }}</span>
                </div>
                <div class="data-group">
                    <span class="data-label">Nro Solicitud:</span>
                    <span class="data-value">{{ solicitud._nro }}</span>
                </div>
                <div class="data-group">
                    <span class="data-label">Fecha Solicitud:</span>
                    <span class="data-value">{{ solicitud.createdAt | date:"dd/MM/yy" }}</span>
                </div>
                <div class="data-group">
                    <span class="data-label">Documentación:</span>
                    <span class="data-value status">{{ estadoDocumentacion }}</span>
                </div>
            </div>

            <div class="col-md-6 data-column">
                
                <div class="data-group">
                    <span class="data-label">Titular:</span>
                    <span class="data-value">{{ solicitud.usuario.fullName }}</span>
                </div>
                <div class="data-group">
                    <span class="data-label">Beneficiario:</span>
                    <span class="data-value">
                        {{ beneficiario?.adicional?.fullName || solicitud.usuario.fullName }}
                    </span>
                </div>
                <div class="data-group">
                    <span class="data-label">Parentesco:</span>
                    <span class="data-value">
                        {{ beneficiario?.parentesco || 'TITULAR' }}
                    </span>
                </div>
                <div class="data-group">
                    <span class="data-label">Progreso:</span>
                    <span class="data-value highlight">
                        {{ solicitud.lastState.numberState | estadosPipe }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Sección Contacto - Versión Simplificada -->
<div class="contacto-section mt-3">
    <h5 class="section-title">Contacto</h5>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center mb-2">
                <span class="data-label me-2">Email:</span>
                <span class="data-value copy-email" (click)="copyToClipboard(usuario.email)">
                    {{ usuario.email }}
                    <span class="copy-feedback">Copiado!</span>
                </span>
            </div>
            <div class="d-flex align-items-center mb-2">
                <span class="data-label me-2">Teléfono:</span>
                <span class="data-value">{{ usuario.paisCodeArea }}{{ usuario.telefono || 'número desconocido' }}</span>
            </div>
        </div>
    </div>
</div>